import { c as _c } from "react/compiler-runtime";
import loadable from '@loadable/component';
import React from 'react';
import PropTypes from 'prop-types';
import AboveTheFoldServerRenderer from 'components/essentials/AboveTheFoldServerRenderer';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPCuralateGallery from './PDPCuralateGallery';
// CON-7309: Temporarily removed to help isolate cause of performance issues
// import BrowserOnly from 'components/consumer/BrowserOnly';

const RecentlyViewed = loadable(() => import('components/consumer/recently-viewed'));

// CON-7309: Temporarily removed to help isolate cause of performance issues
// const RecommendedForYouCarousel = loadable(() =>
//   import('components/consumer/ProductCardCarousel/RecommendedForYouCarousel')
// );

export const PDPRecentlyViewed = t0 => {
  const $ = _c(3);
  const {
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const {
    data
  } = usePDPBasicDetails();
  const t2 = data?.id;
  let t3;
  if ($[0] !== isLayoutRevamp || $[1] !== t2) {
    t3 = <AboveTheFoldServerRenderer disableOnServer={true}><RecentlyViewed currentPDPProduct={t2} isLayoutRevamp={isLayoutRevamp} /></AboveTheFoldServerRenderer>;
    $[0] = isLayoutRevamp;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
PDPRecentlyViewed.propTypes = {
  isLayoutRevamp: PropTypes.bool
};
const PDPFooterInner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><PDPCuralateGallery /><PDPRecentlyViewed /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const PDPFooter = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPFooterInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPFooter;